var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.4997 59.6021L29.4518 55.9171C15.0747 42.88 5.58301 34.2537 5.58301 23.7292C5.58301 15.1029 12.3388 8.375 20.9372 8.375C25.7947 8.375 30.4568 10.6363 33.4997 14.1817C36.5426 10.6363 41.2047 8.375 46.0622 8.375C54.6605 8.375 61.4163 15.1029 61.4163 23.7292C61.4163 34.2537 51.9247 42.88 37.5476 55.9171L33.4997 59.6021Z",
    fill: "#076AFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.2eb784866a13e4e5830df1c77ff0f726.svg";
export { ForwardRef as ReactComponent };